import { render } from "./FilterSales.vue?vue&type=template&id=783fdcce"
import script from "./FilterSales.vue?vue&type=script&lang=js"
export * from "./FilterSales.vue?vue&type=script&lang=js"
script.render = render

export default script